import { TaskCategories } from '@/enums/tasks';
import { PendingTasks } from '@/interfaces/task-user/task-user';
import { TaskDetailAndTotalTasksService } from '@/services/taskDetailAndTotalTasks/task-detail-and-total-tasks.service';
import { StoreState } from '@/store';
import { State } from '@/store/login/reducer';
import { getCurrentUserData } from '@/store/login/selectors';
import { ofuscate } from '@/utils/obfuscation';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { OrderPipe } from 'ngx-order-pipe';
import { catchError, filter } from 'rxjs/operators';

@Component({
  selector: 'app-task-list',
  templateUrl: './task-list.component.html',
  styleUrls: ['./task-list.component.css'],
})
export class TaskListComponent implements OnInit {

  taskPendingListApi: Partial<PendingTasks[]> = [];
  sortedCollection: Partial<PendingTasks[]> = [];
  gettingList: boolean = true;

  constructor(
    private taskService: TaskDetailAndTotalTasksService,
    private router: Router,
    private store: Store<StoreState>,
    private orderPipe: OrderPipe,
  ) {

  }

  ngOnInit() {
    getCurrentUserData(this.store).subscribe({
      next: (userData) => {
        this.userData = userData;
        const taskPending$ = this.taskService.getTotalTaskPending(userData.mdmid).pipe(filter((x) => !!x));
        taskPending$.subscribe({
          next: (response) => {
            this.gettingList = false;
            this.taskPendingListApi = response;
          },
          error: () => {
            this.gettingList = false;
            this.taskPendingListApi = [];
          },
        });
      },
    });
    this.sortedCollection = this.orderPipe.transform(this.taskPendingListApi, 'taskPendingListApi.requirementId');
  }

  get listCount(): number {
    if (this.taskPendingListApi) {
      return this.taskPendingListApi.length;
    }
    return 0;
  }

  userData?: State;

  searchText = '';

  /// ///////////PAGINATE/////////////////

  config: any = {
    id: 'custom',
    itemsPerPage: 5,
    currentPage: 1,
    totalItems: this.taskPendingListApi.length,
  };

  /// ////  ORDENAMIENTO ///////////
  order: string = '';
  // 1 -> disabled ; 2 -> asc ; 3 -> desc
  orderStatus: 1 | 2 | 3 = 1;
  reverse: boolean = false;

  setOrder(headerName: string) {
    if (this.order !== headerName) {
      this.orderStatus = 2;
      this.order = headerName;
    }
    else if (this.orderStatus < 3) {
      this.orderStatus++;
    }
    else {
      this.orderStatus = 1;
      this.order = '';
    }

    if (this.orderStatus === 3) {
      this.reverse = true;
    }
    else {
      this.reverse = false;
    }
  }

  onReviewDetail(id: number | undefined, taskCategory: TaskCategories) {
    if (taskCategory === TaskCategories.ACTUALIZACION_DE_ANTECEDENTES) {
      const ofuscateData = ofuscate({ id });
      this.router.navigateByUrl(`/tasks/background-update/${ofuscateData}`);
    }
    if (taskCategory === TaskCategories.APROBACION) {
      const ofuscatedData = ofuscate({ id, requirementTypeId: taskCategory });
      this.router.navigateByUrl(`/license/approve/detail/${ofuscatedData}`);
    }
    if (taskCategory === TaskCategories.DELEGACION) {
      const ofuscatedData = ofuscate({ id, requirementTypeId: taskCategory });
      this.router.navigateByUrl(`/license/approve/detail/${ofuscatedData}`);
    }
    if (taskCategory === TaskCategories.AMPLIACION) {
      // this.router.navigateByUrl(`/tasks/background-update/${ofuscateData}`);
    }
    if (taskCategory === TaskCategories.RENOVACION) {
      const ofuscatedData = ofuscate({ id, requirementTypeId: taskCategory });
      this.router.navigateByUrl(`/license/approve/detail/${ofuscatedData}`);
    }
  }

}
